export enum PortType {
  BOTH = 0,
  ORIGIN = 1,
  DESTINATION = 2
}

export enum DndType {
  SEPARATE = 0,
  COMBINED = 1
}

export enum PerDiemType {
  FLAT = 0,
  TIER = 1
}

export enum ContractStatus {
  PENDING = 0,
  ACTIVE = 1,
  INACTIVE = 0,
  REJECTED = -1,
  DRAFT = 2,
  HISTORY = 1,
  PORTPAIR_BASED
}

export enum ContractUploadStatus {
  UPLOADED = 0,
  PROCESSING = -1,
  SUCCESS = 1,
  PARTIALLY_SUCCESSFUL = 2,
  FAILED = 3,
  PROCESSING_FAILED = -2
}

 export enum ContractType {
   LOCATION_BASED = 'LOCATION_BASED',
   PORTPAIR_BASED = 'PORTPAIR_BASED'
 }

